import React from 'react';

export default function Mail(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 14"
      /* eslint-disable-next-line react/jsx-props-no-spreading */
      {...props}
    >
      <path
        fill="currentColor"
        d="M2.25 1.688a.578.578 0 0 0-.563.562v.809l6.047 4.957a1.962 1.962 0 0 0 2.496 0l6.082-4.957V2.25c0-.281-.28-.563-.562-.563H2.25Zm-.563 3.55v6.012c0 .316.247.563.563.563h13.5a.578.578 0 0 0 .563-.563V5.238L11.32 9.316c-1.37 1.125-3.304 1.125-4.64 0L1.688 5.238ZM0 2.25C0 1.02.984 0 2.25 0h13.5C16.98 0 18 1.02 18 2.25v9c0 1.266-1.02 2.25-2.25 2.25H2.25A2.221 2.221 0 0 1 0 11.25v-9Z"
      />
    </svg>
  );
}
